"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _lab = require("@material-ui/lab");
var _Translated = _interopRequireDefault(require("../Translated"));
var _style = require("./style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AlertMessage = _ref => {
  let {
    text,
    title,
    children,
    showTitle = true,
    severity = 'error',
    variant = 'outlined',
    minContent: isMinContent = false,
    ...props
  } = _ref;
  const classes = (0, _style.useStyles)(props);
  const renderTitle = () => {
    if (title) {
      return title;
    }
    if (severity === 'error') {
      return /*#__PURE__*/_react.default.createElement(_Translated.default, {
        id: "error"
      });
    }
    if (severity === 'success') {
      return /*#__PURE__*/_react.default.createElement(_Translated.default, {
        id: "success"
      });
    }
    if (severity === 'warning') {
      return /*#__PURE__*/_react.default.createElement(_Translated.default, {
        id: "warning"
      });
    }
    if (severity === 'info') {
      return /*#__PURE__*/_react.default.createElement(_Translated.default, {
        id: "info"
      });
    }
    return title;
  };
  return /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    variant: variant,
    severity: severity,
    className: (0, _clsx.default)({
      [classes.minContent]: isMinContent
    })
  }, showTitle && renderTitle() && /*#__PURE__*/_react.default.createElement(_lab.AlertTitle, null, renderTitle()), children || text);
};
var _default = exports.default = AlertMessage;